import { ButtonGroup, ButtonV2, SearchV2, TooltipV2 } from '@cimplico/components';
import {
    ArrowsPointingInIcon,
    ArrowsPointingOutIcon,
    FolderPlusIcon,
    QueueListIcon,
    SquaresPlusIcon,
    PlusCircleIcon,
    TableCellsIcon,
} from '@heroicons/react/20/solid';

type TopActionsProps = {
    onAdd: (type: 'LIST' | 'SECTION_GROUP' | 'SECTION' | 'FIELD' | 'TABLE') => void;
};

function TopActions({ onAdd }: TopActionsProps): JSX.Element {
    return (
        <div className="flex items-center gap-4 w-full">
            <TooltipV2 message="Collapse All" position="left">
                <ButtonV2 size="xs" type="secondary" leftIcon={<ArrowsPointingInIcon />} onClick={console.log} />
            </TooltipV2>
            <TooltipV2 message="Expand All">
                <ButtonV2 size="xs" type="secondary" leftIcon={<ArrowsPointingOutIcon />} onClick={console.log} />
            </TooltipV2>
            <div className="grow">
                <SearchV2 size="small" placeholder="Search fields..." onChange={console.log} />
            </div>
            <ButtonGroup
                label="New section"
                leftIcon={<FolderPlusIcon />}
                type="secondary"
                size="sm"
                onClick={(): void => onAdd('SECTION')}
            >
                <ButtonGroup.SecondaryAction label="New field" leftIcon={<PlusCircleIcon />} onClick={(): void => onAdd('FIELD')} />
                <ButtonGroup.SecondaryAction
                    label="New section group"
                    leftIcon={<SquaresPlusIcon />}
                    onClick={(): void => onAdd('SECTION_GROUP')}
                />
                <ButtonGroup.SecondaryAction label="New table" leftIcon={<TableCellsIcon />} onClick={(): void => onAdd('TABLE')} />
                <ButtonGroup.SecondaryAction label="New list" leftIcon={<QueueListIcon />} onClick={(): void => onAdd('LIST')} />
            </ButtonGroup>
        </div>
    );
}

export default TopActions;
